// Conversation screen layout used across pages.
import { useState } from "react";
import { ScrollView, StyleSheet, View } from "react-native";
import { useIsEmbedded, useIsInSidebar, useSiloKey } from "util/datastore";
import { Pad, Center, HorizBox, AdaptiveWidth } from "./basics";
import { colorAmbiguousHighlight, colorBorderPrimary, colorSurfacePrimary } from "./color";
import { UtilityText, WebLinkTextButton } from "./text";


export function ConversationScreen({ children, backgroundColor = colorSurfacePrimary, pad = false, noWrap = false }) {
    const s = ConversationScreenStyle;
    const embedded = useIsEmbedded();
    const isInSidebar = useIsInSidebar();
    const [narrow, setNarrow] = useState(false);
    const useWrapper = !isInSidebar && !narrow && !noWrap;
    const hasEmulateWarning = window.location.hostname == 'localhost' && !embedded;

    return <AdaptiveWidth setNarrow={setNarrow} breakpoint={540} style={{flex:1}}>
        <ScrollView style={[s.scroller, useWrapper ? null : { backgroundColor }] }>
            {useWrapper && <Pad size={40} />}
            <View style={s.outer}>
                <View style={[s.screen,
                    pad ? { paddingHorizontal: 20 } : null,
                    useWrapper ? s.wrapper : null]}>
                    {children}
                </View>
            </View>
            {useWrapper && <Pad size={48} />}
            <NewPublicFooter />
            {hasEmulateWarning && <Pad size={36} />}
        </ScrollView>
    </AdaptiveWidth>;
}

export const ConversationScreenStyle = StyleSheet.create({
    wrapper: {
        borderRadius: 12,
        borderColor: colorBorderPrimary,
        borderWidth: 1,
        overflow: 'hidden',
    },
    scroller: {
        flex: 1,
        ...{overscrollBehavior: 'none'} as any
    },
    outer: {
        flexDirection: 'row',
        justifyContent: 'space-around',
        backgroundColor: colorSurfacePrimary,
        flex: 1
    },
    screen: {
        maxWidth: 600,
        flex: 1
    },
});
export function NewPublicFooter() {
    const siloKey = useSiloKey();
    if (siloKey != 'np') return null;
    return <Center>
        <HorizBox center>
            <UtilityText type='large' label='Made by ' mono />
            <WebLinkTextButton type='large' color={colorAmbiguousHighlight} mono url='https://newpublic.org' text='New_ Public' />
        </HorizBox>
        <Pad size={80} />
    </Center>;
}

